import React from 'react';
import  PreChilderensDay2023  from 'views/PreChilderensDay2023';
// import ChilderensDay2023 from 'views/ChilderensDay2023/Index'

const SchoolProgrampage = () => {
  return <PreChilderensDay2023 />;
};

export default SchoolProgrampage;